import {
  START_ACTIVE_EDITING,
  STOP_ACTIVE_EDITING,
} from "../constants/ActionTypes";

// Tracks how many editing sessions are currently active (counter).
// Any component with unsaved in-progress input increments this counter.
// AutoSave components check this to defer PATCH calls while the user is editing.
export default function activeEditingReducer(state = 0, action) {
  switch (action.type) {
    case START_ACTIVE_EDITING:
      return state + 1;
    case STOP_ACTIVE_EDITING:
      return Math.max(0, state - 1);
    default:
      return state;
  }
}
